<template>
	<div class="new-list">
		<HeaderBar></HeaderBar>
		<section class="blog-classic">
			<div class="container">
				<b-breadcrumb>
					<b-breadcrumb-item to="/">首页</b-breadcrumb-item>
					<b-breadcrumb-item active="">{{ categoryName }}</b-breadcrumb-item>
				</b-breadcrumb>
				<div class="hg-20"></div>
				<div class="row">
					<div class="col-lg-6" v-for="item in newList" :key="item.id">
						<div class="blog-one__single">
							<div class="blog-one__image">
								<img :src="item.thumbnail" alt="" width="100%" />
							</div>
							<div class="content">
								<div class="blog-one__meta">
									<i class="fa fa-clock-o"></i> {{ item.create_time }}
								</div>
								<h2 class="blog-one__title">
									{{ item.post_title }}
								</h2>
								<p class="blog-one__text">
									{{ item.post_excerpt }}
								</p>
								<b-button squared variant="success" @click="goDetail(item.id)"
									>阅读更多</b-button
								>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-12">
						<b-pagination
							v-model="page.currentPage"
							:total-rows="page.total_page"
							:per-page="page.perPage"
						></b-pagination>
					</div>
				</div>
			</div>
		</section>
		<FooterBar></FooterBar>
	</div>
</template>

<script>
import HeaderBar from '@/components/header-bar';
import FooterBar from '@/components/footer-bar';
import { baseUrl } from '../../config/config';
export default {
	name: 'newlist',
	components: {
		HeaderBar,
		FooterBar,
	},
	data() {
		return {
			category_id: this.$route.query.category_id,
			categoryName: this.$route.query.categoryName,
			page: {
				total_page: 0, //总页数
				currentPage: 1, //当前页数
				perPage: 1,
				pageSize: 10, //每页显示多少条
			},
			newList: [], //新闻列表
		};
	},
	computed: {},
	mounted() {
		this.getNewList();
	},
	methods: {
		goDetail(id) {
			this.$router.push({
				path: 'new-detail',
				query: {
					id: id,
				},
			});
		},
		//获取文章列表
		getNewList() {
			let params = {
				do: 'list',
				category_id: this.category_id,
				page: this.page.currentPage,
				pageSize: this.page.pageSize,
			};
			this.$axios
				.post(baseUrl + '/portal/article/index', params)
				.then((res) => {
					if (res.data.code === 1) {
						this.newList = res.data.data.data;
						this.page.per_page = res.data.data.per_page;
						this.page.total_page = res.data.data.total_page;
						this.page.currentPage = res.data.data.current_page;
					}
				});
		},
	},
};
</script>
<style lang="scss">
.new-list {
	.breadcrumb-item a {
		color: #007bff !important;
	}
	.breadcrumb-item a:hover {
		color: #007bff !important;
	}
	.page-item.active .page-link {
		background-color: #007bff;
		border-color: #007bff;
	}
	.blog-classic {
		padding-top: 25px;
		padding-bottom: 50px;
	}

	.blog-classic .blog-one__single {
		margin-bottom: 50px;
		transition: all 0.5s;
		.blog-one__image {
			overflow: hidden;
		}
		&:hover {
			box-shadow: 0px 0px 10px #ddd;
		}
		.content {
			padding: 1rem;
		}
	}

	.blog-classic .blog-one__title {
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 30px;
		line-height: 36px;
		color: #333;
	}

	.blog-classic .blog-one__meta {
		color: #848484;
		margin-bottom: 0.6rem;
	}

	.blog-classic .thm-btn {
		padding: 13px 31.4px;
	}

	.blog-classic .blog-one__text {
		margin-bottom: 25px;
		margin-top: 20px;
		color: #848484;
		font-size: 0.8rem;
	}
	.pagination {
		justify-content: center;
	}
}
</style>
<style></style>
